import getOrganization from './getSkillorganization';
import getOrganizationDetails from './getOrganizationDetails';
import textInputSchema from './textInputSchema';

export default (params) => {
  const { preTag } = params;

  let schema;
  if (preTag === 'skill') {
    schema = {
      blocks: {
        [`${preTag}_organization`]: getOrganization(params),
        [`${preTag}_organization_details`]: getOrganizationDetails(params),
        [`${preTag}_organization_name`]: textInputSchema,
        [`${preTag}_title`]: textInputSchema,
        paragraph: { nodes: [{ match: { object: 'text' } }] },
      },
    };
  } else {
    schema = {
      document: {
        nodes: [
          {
            match: { type: preTag },
            min: 1,
          },
        ],
      },
      blocks: {
        [preTag]: {
          nodes: [
            {
              match: { object: 'text' },
              max: 1,
            },
          ],
        },
      },
    };
  }

  return schema;
};

export const getTextSchema = () => ({
  nodes: [{ match: { object: 'text' } }],
});
